interface EnvironmentConfig {
  REACT_APP_ENV: string;
  REACT_APP_BUILD_NUMBER?: string;

  REACT_APP_API_ENDPOINT_URL: string;
  REACT_APP_WEB_URL: string;
  REACT_APP_IOS_BUNDLE_ID: string;
  REACT_APP_ANDROID_PACKAGE_NAME: string;
  REACT_APP_GOOGLE_OAUTH_CLIENT_ID: string;

  REACT_APP_FIREBASE_API_KEY: string;
  REACT_APP_FIREBASE_AUTH_DOMAIN: string;
  REACT_APP_FIREBASE_PROJECT_ID: string;
  REACT_APP_FIREBASE_STORAGE_BUCKET: string;
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID: string;
  REACT_APP_FIREBASE_APP_ID: string;
  REACT_APP_FIREBASE_MEASUREMENT_ID: string;

  REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID?: string;

  REACT_APP_SMARTLOOK_KEY?: string;
  REACT_APP_FULLSTORY_ORG_ID?: string;
  REACT_APP_INTERCOM_KEY?: string;
  REACT_APP_SENTRY_DSN: string;
  REACT_APP_SENTRY_TRACING_RATE: string;
}

const getEnv = (): EnvironmentConfig => {
  return process.env as any;
};

export const env = getEnv();
